// extracted by mini-css-extract-plugin
module.exports = {"getInTouch":"getInTouch_getInTouch__3XL2B","ctaWrapper":"getInTouch_ctaWrapper__2V5mb","content":"getInTouch_content__tmedB"};